var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Jamaica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7cb342",
    d: "M38.591,10.351C34.941,6.451,29.763,4,24,4S13.059,6.451,9.409,10.351L24,20.2L38.591,10.351z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7cb342",
    d: "M38.591,37.649L24,27.8L9.409,37.649C13.059,41.549,18.237,44,24,44S34.941,41.549,38.591,37.649z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M5.882,15.57C4.687,18.135,4,20.984,4,24c0,3.016,0.687,5.865,1.882,8.43L18.37,24L5.882,15.57z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M42.118,32.43C43.313,29.865,44,27.016,44,24c0-3.016-0.687-5.865-1.882-8.43L29.63,24L42.118,32.43 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M24,20.2L9.409,10.351c-1.436,1.534-2.629,3.292-3.527,5.219L18.37,24L24,20.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M24,27.8l14.591,9.849c1.436-1.534,2.629-3.292,3.527-5.219L29.63,24L24,27.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M29.63,24l12.488-8.43c-0.899-1.928-2.091-3.685-3.527-5.219L24,20.2L18.37,24L5.882,32.43 c0.899,1.928,2.091,3.685,3.527,5.219L24,27.8L29.63,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Jamaica);
export default __webpack_public_path__ + "static/media/icons8-jamaica.96e72f86a1320799946ee54e98dccf61.svg";
export { ForwardRef as ReactComponent };